import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, concatMap, take } from 'rxjs';
import { S3PresignedUrl } from 'src/app/classes/s3-presigned-url';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service';

import { License } from '../classes/models/license';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {
  constructor(
    private http: HttpClient,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  // For now, we'll make this admin only. Can alter this for Vendors to use if need be.
  getLicense(query = {}) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Vendor: () =>
            this.http.get<License>(
              `/api/v2/vendor/${this.AuthService.getUserVendorId()}/license/one`,
              { params: query }
            ),
          Admin: () =>
            this.http.get<License>(`/api/v2/admin/license/one`, {
              params: query
            })
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }

  getLicenses(VendorId: number, query = {}) {
    return this.http.get<License[]>(`/api/v2/vendor/${VendorId}/license/many`, {
      params: query
    });
  }

  saveLicense(VendorId: number, License: License, query = {}) {
    return this.http.post<License>(
      `/api/v2/vendor/${VendorId}/license/one`,
      License,
      { params: query }
    );
  }

  getLicenseFileS3PresignedUrl(VendorId: number, LicenseId: number) {
    return this.http.get<S3PresignedUrl>(
      `/api/v2/vendor/${VendorId}/license/${LicenseId}/presignedUrl`
    );
  }
}
